/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {
  GET_USER_JOBS_REQUEST,
  GET_USER_JOBS_SUCCESS,
  GET_USER_JOBS_FAILURE,
} from 'actions/job';

import {
  SEARCH_JOBS_REQUEST,
  SEARCH_JOBS_SUCCESS,
  SEARCH_JOBS_FAILURE,
} from 'actions/search';

const initialState = {
  loading: true,
  query: {},
  pagination: {},
  items: [],
};

/**
 * This is the profile reducer. It listens for actions and updates the profile state object.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export default function(state = initialState, { type, payload }) {
  switch (type) {
    case GET_USER_JOBS_REQUEST:
    case SEARCH_JOBS_REQUEST:
      return initialState;

    case GET_USER_JOBS_SUCCESS:
    case SEARCH_JOBS_SUCCESS:
      return {
        ...state,
        query: payload.query,
        pagination: payload.pagination,
        items: payload.jobs,
        loading: false,
      };

    case GET_USER_JOBS_FAILURE:
    case SEARCH_JOBS_FAILURE:
      return initialState;

    default:
      return state;
  }
}
